<template>
    <div>
        案例报告
    </div>
</template>

<script>
    export default {
        name: "caseReport"
    }
</script>

<style scoped>

</style>